export type RouteConstantValues = "/" | "/faq";

const RouteConstants = {
  BASE: "/" as RouteConstantValues,
  FAQ: "/faq" as RouteConstantValues,
  DETAILS: "/details/",
};

export default RouteConstants;
